import React from 'react'
import { Button, MenuItem, Select, IconButton } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'
import { FormattedMessage, useIntl } from 'react-intl'
import { useStyles } from './Styles'
import { useTheme } from '@material-ui/core/styles'
import { ChevronLeft, ChevronRight } from '@material-ui/icons'

const InvoicesList = ({
                        handleListingFilterSubmit, noFilter, listingData, listingPage, columns, title,
                        listingCount, listingRowsPerPage, handleChangeListingPage, handleChangeListingRowsPerPage, noPagination,
                        hasContinuationToken, continuationTokens, currentIndex, submitFilterRef, setFilterData
                      }) => {
  const classes = useStyles()
  const theme = useTheme()
  const intl = useIntl()

  const changeFilter = (applyFilters) => {
    let filterList = applyFilters()
    let allFiltersData = {}
    let filters = {}
    if (!!filterList.length) {
      filterList.forEach((filterItem, index) => {
        allFiltersData[columns[index].key_name] = filterItem
        if (!!filterItem.length) {
          if (!!filterItem[0] && filterItem[0]?.toString().length >= 1) {
            filters[columns[index].key_name] = filterItem[0]
          }
        }
      })
    }
    if (!!setFilterData) {
      setFilterData(allFiltersData)
    }
    handleListingFilterSubmit(filters, null, true)
  }
  const [newColumns, setNewColumns] = React.useState(columns || [])
  const [columnsDisplay, setColumnsDisplay] = React.useState([])
  React.useEffect(() => {
    if (!!columnsDisplay?.length && !!columns?.length) {
      setNewColumns(columns.map((col, index) => {
        if (!col.options.viewColumns) {
          col.options.display = columnsDisplay[index]
        }
        return col
      }))
    }
    // eslint-disable-next-line
  }, [columns, columnsDisplay])

  React.useEffect(() => {
    if (!!columns.length) {
      setColumnsDisplay(columns.map(col => col.options.hasOwnProperty('display') ? col.options.display : 'true'))
    }
    // eslint-disable-next-line
  }, [])

  const handleChangeColumnDisplay = (columnName, display) => {
    let colIndex = columns.map(column => column.name).indexOf(columnName)
    let updatedColumns = [...columnsDisplay]
    updatedColumns[colIndex] = display
    setColumnsDisplay(updatedColumns)
  }


  const options = {
    filter: !noFilter,
    filterType: 'dropdown',
    responsive: 'simple',
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    serverSide: true,
    count: listingCount,
    search: false,
    pagination: !noPagination,
    jumpToPage: !noPagination,
    rowsPerPage: listingRowsPerPage,
    ...hasContinuationToken && {
      customFooter: () => (
        <tfoot className='MuiTableFooter-root'>
        <tr className='MuiTableRow-root'>
          <td colSpan={1000} className={classes.paginationWithToken}>
            <div>
              <span className={'per-page'}>{intl.formatMessage({ id: 'Table.List.Table.RowsPerPage' })} </span>
              <Select value={listingRowsPerPage} onChange={e => handleChangeListingRowsPerPage(e.target.value)}>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </div>

            <IconButton onClick={() => handleChangeListingPage('previous')} disabled={listingPage === 0}>
              {theme.direction === 'ltr' ? <ChevronLeft/> : <ChevronRight/>}
            </IconButton>

            {/* <span style={{ marginLeft: 8, marginRight: 8 }}>{listingRowsPerPage}</span> */}
            <IconButton
              disabled={currentIndex === continuationTokens.length - 2 && continuationTokens[currentIndex + 1] === 'EndofResultSet'}
              onClick={() => handleChangeListingPage('next')}>
              {theme.direction === 'ltr' ? <ChevronRight/> : <ChevronLeft/>}
            </IconButton>
          </td>
        </tr>
        </tfoot>
      )
    },

    // rowsPerPageOptions: [10, 25, 50, 100, 200],
    rowsPerPageOptions: [10, 25, 50, 100],
    onChangePage: handleChangeListingPage,
    onChangeRowsPerPage: handleChangeListingRowsPerPage,
    // sortOrder: sortListingOrder,
    // page: listingPage > -1 ? listingPage : 0,
    // page: false,
    confirmFilters: true,
    fixedHeader: true,
    fixedSelectColumn: true,
    // tableBodyMaxHeight: '680px',
    print: false,
    download: false,
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div className={classes.ApplyFilterWrapper}>
          <Button color='primary' ref={submitFilterRef}
                  variant="contained" onClick={() => changeFilter(applyNewFilters)}>
            <FormattedMessage id='Requests.List.Table.ApplyFilters'/></Button>
        </div>
      )
    },
    onFilterChange: (column, filterList, type) => {
      if (type === 'chip' ||
        (typeof column === 'string' && typeof type === 'string' && type === 'custom'
          && ['uuid',
            'msUUID',
            'internalId',
            'typeName',
            'status',
            'MSStatus',
            'dateFrom',
            'dateTo',
            'submissionDateFrom',
            'submissionDateTo',
            'receiverType',
            'issuerType',
            'issuerId'
          ].includes(column))) {
        if (column === 'uuid') {
          let stateIndex = columns.map(column => column.name).indexOf('uuid')
          if (stateIndex > -1 && filterList.length) {
            filterList[stateIndex] = []
          }
        } else if (['dateFrom', 'dateTo'].includes(column)) {
          let columnsName = columns.map(column => column.key_name)
          let dateToIndex = columnsName.indexOf('issueDateTo')
          let dateFromIndex = columnsName.indexOf('issueDateFrom')
          if ((dateToIndex > -1 || dateFromIndex > -1) && filterList.length) {
            filterList[dateToIndex] = []
            filterList[dateFromIndex] = []
          }
        } else if (['submissionDateFrom', 'submissionDateTo'].includes(column)) {
          let columnsName = columns.map(column => column.key_name)
          let dateToIndex = columnsName.indexOf('submissionDateTo')
          let dateFromIndex = columnsName.indexOf('submissionDateFrom')
          if ((dateToIndex > -1 || dateFromIndex > -1) && filterList.length) {
            filterList[dateToIndex] = []
            filterList[dateFromIndex] = []
          }
        }
        let newFilters = () => (filterList)
        changeFilter(newFilters)
      }
    },
    onViewColumnsChange: (changedColumn, action) => {
      handleChangeColumnDisplay(changedColumn, action.toString() === 'add' ? 'true' : 'false')
    },
    textLabels: {
      body: {
        noMatch: intl.formatMessage({ id: 'Invoices.List.Table.NoMatching' }),
        toolTip: intl.formatMessage({ id: 'Table.List.Table.Sort' }),
        columnHeaderTooltip: column => intl.formatMessage(
          { id: 'Table.List.Table.SortFor' },
          { label: column.label })
      },
      pagination: {
        next: intl.formatMessage({ id: 'Table.List.Table.NextPage' }),
        previous: intl.formatMessage({ id: 'Table.List.Table.PreviousPage' }),
        rowsPerPage: intl.formatMessage({ id: 'Table.List.Table.RowsPerPage' }),
        jumpToPage: intl.formatMessage({ id: 'Table.List.Table.jumpToPage' }),
        displayRows: intl.formatMessage({ id: 'Table.List.Table.Of' })
      },
      toolbar: {
        search: intl.formatMessage({ id: 'Table.List.Table.Search' }),
        downloadCsv: intl.formatMessage({ id: 'Table.List.Table.Download' }),
        print: intl.formatMessage({ id: 'Table.List.Table.Print' }),
        viewColumns: intl.formatMessage({ id: 'Table.List.Table.ViewColumns' }),
        filterTable: intl.formatMessage({ id: 'Table.List.Table.FilterTable' })
      },
      filter: {
        all: intl.formatMessage({ id: 'Table.List.Table.All' }),
        title: intl.formatMessage({ id: 'Table.List.Table.FILTERS' }),
        reset: intl.formatMessage({ id: 'Table.List.Table.RESET' })
      },
      viewColumns: {
        title: intl.formatMessage({ id: 'Table.List.Table.ShowColumns' }),
        titleAria: intl.formatMessage({ id: 'Table.List.Table.ShowHideColumns' })
      }
    },
    onTableChange: (action, tableState) => {
      // if ('changePage' === action) {
      //   changePage(tableState.page, tableState.sortOrder)
      // }
      // switch (action) {
      //   // case 'changePage':
      //   //   changePage(tableState.page, tableState.sortOrder)
      //   //   break
      //   case 'sort':
      //     sortListingData(tableState.sortOrder)
      //     break
      //   default:
      //     break
      // }
    }
  }
  return (
    <MUIDataTable
      title={title}
      data={listingData}
      columns={newColumns}
      options={options}
    />
  )
}

export default InvoicesList
